import { render } from "./ZircVenFall.vue?vue&type=template&id=fde39870"
import script from "./ZircVenFall.vue?vue&type=script&lang=js"
export * from "./ZircVenFall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__